import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

type AuthDividerProps = Readonly<{
  label?: string;
}>;

export default function OauthDivider({ label }: AuthDividerProps) {
  const { t } = useTranslation();
  const displayLabel = label ? t(label) : t("LABEL_SIGN_IN_WITH");

  return (
    <View className="flex-row items-center mb-7">
      <View className="flex-1 h-px bg-ash-3" />
      <Text className="mx-4 text-slate">{displayLabel}</Text>
      <View className="flex-1 h-px bg-ash-3" />
    </View>
  );
}
